import { useState } from "react";
import { useModal } from "../contexts";
import { Source } from "../interfaces";
import Modal from "./Modal";
import TextInputField from "./TextInputField";
import { useTranslation } from "react-i18next";

interface Props {
  source: Source;
  updateBlock: (name: any) => void;
}

function WorkflowModalWebhookNameChange({ source, updateBlock }: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();
  const [name, setName] = useState<string>(source.webhookConfig!.name);

  return (
    <Modal
      title={t("Update Webhook Source Name")}
      secondaryButtonProps={{ onClick: closeModal, text: t("Cancel") }}
      primaryButtonProps={{ onClick: () => { updateBlock(name); closeModal(); }, text: t("Update") }}
      size="sm"
    >
      <TextInputField label={t("Webhook Source Name")} value={name} onChange={name => setName(name)} />
    </Modal>
  )
}

export default WorkflowModalWebhookNameChange;
